var _path, _polygon, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    enableBackground: "new 0 0 120 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1668D",
    d: "M119,109.617c0,4.997-4.199,9.383-9.2,9.383H10.571c-5,0-9.571-4.386-9.571-9.383V10.383 C1,5.385,5.571,1,10.571,1H109.8c5.001,0,9.2,4.385,9.2,9.383V109.617z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.1289,
    y1: 88.1611,
    x2: 91.2598,
    y2: 12.0303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9BEC6",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7256,
    style: {
      stopColor: "#DE1B53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    style: {
      stopColor: "#DF2758"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9204,
    style: {
      stopColor: "#EB698E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F27FA7"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "46.725,68.819 16.094,89.126 0.707,69.669 86.284,14.909 107.716,28.486  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0195,
    y1: 109.4551,
    x2: 124.5536,
    y2: 67.2054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9BEC6",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7256,
    style: {
      stopColor: "#DE1B53"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M119,109.945V71.555l-11.074-43.521L16.2,88.678L33.499,119h76.029 C114.524,119,119,114.943,119,109.945z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.8984,
    y1: 87.7422,
    x2: 103.7711,
    y2: 72.4134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#DE1B53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    style: {
      stopColor: "#DF2758"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8539,
    style: {
      stopColor: "#EB698E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F27FA7"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M104.913,75.749c2.489,10.12-3.358,20.264-13.065,22.654c-9.706,2.391-19.598-3.875-22.09-13.997 s3.355-20.264,13.064-22.652C92.53,59.361,102.418,65.629,104.913,75.749z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.4f5853f5e62c0cedfb764fb7ef310532.svg";
export { ForwardRef as ReactComponent };